import Faq from '@/components/Faq'
import Footer from '@/components/Footer'
import GoldDivider from '@/components/GoldDivider'
import Hero from '@/components/Hero'
import LaserCalculator from '@/components/LaserCalculator'
import Navbar from '@/components/Navbar'
import NicheCards from '@/components/NicheCards'
import PainMatrix from '@/components/PainMatrix'
import TattooCalculator from '@/components/TattooCalculator'
import { useHead } from '@unhead/react'

const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'How much does a tattoo cost near me?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Local tattoo costs vary by region: expect $80-$150 for small pieces, $150-$450 for medium designs, and $800-$3,000+ for large works like full sleeves or back pieces.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is the tattoo hourly rate?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Apprentice artists charge around $90/hour, Professional Studio artists charge around $160/hour, and Elite Specialist artists charge $270/hour or more.',
      },
    },
    {
      '@type': 'Question',
      name: 'How many sessions are required for laser tattoo removal?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Most tattoos require 6-10 laser removal sessions spaced 6-8 weeks apart, varying by ink density, color, and skin tone.',
      },
    },
  ],
}

function Home() {
  useHead({
    title: 'Tattoo Cost Calculator | Advanced Price & Laser Removal Estimator',
    meta: [
      {
        name: 'description',
        content: 'Free advanced tattoo cost calculator and laser tattoo removal cost estimator. Calculate tattoo price by size, placement, style, and artist tier, plus removal sessions and cost per session.',
      },
    ],
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(FAQ_SCHEMA),
      },
    ],
  })

  return (
    <div className="min-h-screen bg-[#0a0908] font-sans text-slate-100">
      <Navbar />
      <main id="main-content">
        <Hero />
        <GoldDivider />
        <TattooCalculator />
        <GoldDivider />
        <LaserCalculator />
        <GoldDivider />
        <PainMatrix />
        <GoldDivider />
        <NicheCards />
        <GoldDivider />
        <Faq />
      </main>
      <Footer />
    </div>
  )
}

export default Home
